<div class="policy-container">
    <div class="policy-content" [innerHTML]="'policy-page.main-text' | translate">
    </div>
    <div class="button-content">
        <app-policy></app-policy>
    </div>
</div>
